export default __webpack_public_path__ + "static/leaf-group-95f9277b9ee68c1b12d886c3c759c2e5.svg";